import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { AlertController, ModalController } from '@ionic/angular';
import { ApiService } from 'src/app/api/api.service';
import { GlobalService } from 'src/app/api/global.service';
import { StepStatus } from 'src/app/components/steps/StepStatus';
import { ClientStepTypes, StepTypes } from 'src/app/components/steps/StepTypes';
import { SetupPage } from 'src/app/esignature/setup/setup.page';
import { DetailsPage as EmailDetailsPage } from 'src/app/secure-email/details/details.page';
import { DetailsPage as TaskDetailsPage } from 'src/app/tasks/details/details.page';
import { DetailsPage as ProjectDetailsPage } from 'src/app/projects/details/details.page';
import { UploadComponent } from 'src/app/components/files/upload/upload.component';
import * as dayjs from 'dayjs';

@Component({
  selector: 'app-details',
  templateUrl: './details.page.html',
  styleUrls: ['./details.page.scss'],
})
export class DetailsPage implements OnInit {
  stepTypeEnum = StepTypes;
  clientStepTypes = ClientStepTypes;

  @Input() guid: any;
  @Input() project: any = null;
  @Input() task: any = null;
  step: any = null;
  email: any = null;
  previous_step: any = null;
  @Input() edit_mode = false;
  // Opened from somewhere that was starting a "review before sending" client action - go straight into review.
  @Input() review_on_open = false;
  // Reviewing a "review before sending" client action: edit mode, but saving also sends it (see SendReviewedEmail).
  review_mode = false;
  loaded_step = false;
  activeIndex = 'Details';
  // Opened from an @mention notification: the comment to scroll to and highlight on the Comments tab
  @Input() focus_comment: any = null;
  refresh = false;
  current_user: any = null;


  comment: any = {
    reply_to: null,
    reply_to_text: null,
    comment: ''
  }
  step_copy = '';
  loaded_files = false;
  total_comment_count: number = 0;
  comment_filter: string = 'This Action';
  all_comments: any[] = [];
  this_step_comments: any[] = [];
  other_step_comments: any[] = [];
  task_comments_list: any[] = [];
  project_comments_list: any[] = [];
  comments_loading: boolean = false;
  active_reply_guid: string = null;
  reply_comment: any = { reply_to: null, reply_to_text: null, reply_to_name: null, comment: '', update: false };


  constructor(private modalController: ModalController, private apiService: ApiService, public globalService: GlobalService, private alertController: AlertController) { }

  ngOnInit() {
    this.current_user = this.globalService.GetCurrentUser();
    this.GetData();
  }


  async GetData() {
    this.loaded_step = false;
    console.log("Get DATA");
    let data: any = await this.apiService.get(`steps/${this.guid}`);

    console.log(JSON.stringify(data));
    this.step = data.data[0];

    if (this.step.status == 1 && this.step.type === 20 && this.step.step_files) {
      for (let file of this.step.step_files) {
        let file_data: any = await this.apiService.get(`files/${file.file_guid}/info`);
        if (file_data.success && file_data.data.length > 0) {
          Object.assign(file, file_data.data[0]);
        }
      }
      this.loaded_files = true;
    }

    if(this.project == null) { 
      let project_data: any = await this.apiService.get(`projects/${this.step.project_guid}`);
      if(project_data.success) {
        this.project = project_data.data[0];
      }
    }
    if(this.task == null) {
      let task_data: any = await this.apiService.get(`tasks/${this.step.task_guid}`);
      if(task_data.success) {
        this.task = task_data.data[0];
      }
    }
    //Get Previous Step
    const currentStepIndex = this.task.steps.findIndex(s => s.guid === this.step.guid);
    if (currentStepIndex > 0) {
      this.previous_step = this.task.steps[currentStepIndex - 1];
    } else {
      this.previous_step = null;
    }


    this.loaded_step = true;
    if (this.review_on_open) {
      this.review_on_open = false;
      if (this.IsReviewBeforeSending()) this.BeginEmailReview();
    }
    this.GetTotalCommentCount();
    if (this.activeIndex === 'Comments') this.GetComments();
    console.log("!!!!!!!!!!!!!!!!!!!!!");
    console.log("STEP ", this.step);
    console.log("Previous Step ", this.previous_step);

    // Initialize uploaded_files for document request steps
    if (this.step.type == StepTypes.document_request && this.GetStepEmailGuid()) {
      console.log("Initializing uploaded files for document request step");
      await this.GetEmailDetails();
      await this.GetDocumentRequestFiles();
    }

        if (this.step?.data?.surveys?.length) {
      this.step.data.surveys = this.step.data.surveys
        .map((s: any) => Array.isArray(s) ? (s[0] ?? null) : s)
        .filter(Boolean);
    }
  }

  IsEmailBackedStepType(stepType: number): boolean {
    return [
      StepTypes.email,
      StepTypes.document_request,
      StepTypes.signature_request,
      StepTypes.survey,
      StepTypes.approval_request,
      StepTypes.appointment_request,
      StepTypes.question_request,
      StepTypes.checklist_request
    ].includes(stepType);
  }

  GetStepEmailGuid(): string | null {
    return this.step?.steps_data?.[0]?.email_guid || null;
  }

  ShouldShowEmailDetails(): boolean {
    return this.IsEmailBackedStepType(this.step?.type)
      && this.step?.status != StepStatus.incomplete
      && !this.edit_mode
      && !!this.GetStepEmailGuid();
  }

  // True while we wait for the email of an action that was just started to show up (see WaitForStartedEmail)
  waiting_for_email = false;

  ShouldShowMissingEmailNotice(): boolean {
    return !this.waiting_for_email
      && this.IsEmailBackedStepType(this.step?.type)
      && this.step?.status == StepStatus.complete
      && !this.edit_mode
      && !this.GetStepEmailGuid();
  }

  async GetEmailDetails() {
    const emailGuid = this.GetStepEmailGuid();
    if (!emailGuid) return;

    let data: any = await this.apiService.get(`emails/${emailGuid}`);
    console.log("email data", data);
    if (data.success) {
      this.email = data.data[0];
      this.email.requested_documents = [];
      this.email.files = [];
      await this.GetEmailFiles();
    }
  }

  async GetEmailFiles() {
    const emailGuid = this.GetStepEmailGuid();
    if (!emailGuid) return;

    let data: any = await this.apiService.get(`emails/files/${emailGuid}`);
    if(data.success) this.email.files = data.data;
    else this.email.files = [];
  }

  async GetDocumentRequestFiles() {
    const emailGuid = this.GetStepEmailGuid();
    if (!emailGuid || !this.email) return;

    let data: any = await this.apiService.get(`emails/${emailGuid}/document_requests`);
    if(data.success) this.email.requested_documents = data.data;
    else this.email.requested_documents = [];

    console.log("Requested Files:", this.email.requested_documents);
  }


  IsPreviousTaskCompleted() {
    if (!this.project || !this.project.tasks || this.project.tasks.length === 0 || !this.task) {
      return true;
    }
    if(!this.project.force_order) {
      return true;
    } 

    const currentTaskIndex = this.project.tasks.findIndex(t => t.guid === this.task.guid);
    if (currentTaskIndex <= 0) {
      return true;
    }

    const previousTask = this.project.tasks[currentTaskIndex - 1];
    if(previousTask.status != 1) return false;
    else return true;
  }


  async GetTotalCommentCount() {
    const data: any = await this.apiService.get(`projects/${this.step.project_guid}/all_comments?count=1`);
    if (data.success && data.data?.[0]) this.total_comment_count = data.data[0].count;
  }

  async GetComments() {
    this.comments_loading = true;
    this.comment_filter = 'This Action';

    const result: any = await this.apiService.get(`projects/${this.step.project_guid}/all_comments`);
    const all: any[] = result.success ? (result.data || []) : [];

    this.this_step_comments = [];
    this.other_step_comments = [];
    this.task_comments_list = [];
    this.project_comments_list = [];

    for (const c of all) {
      if (c.source_type === 'project') {
        this.project_comments_list.push(c);
      } else if (c.source_type === 'task' && c.source_guid === this.task?.guid) {
        this.task_comments_list.push(c);
      } else if (c.source_type === 'step') {
        if (c.source_guid === this.step.guid) {
          this.this_step_comments.push({ ...c, source_type: 'this_step' });
        } else {
          this.other_step_comments.push({ ...c, source_type: 'other_step' });
        }
      }
    }

    // Format users field by parsing JSON strings
    const formatComments = (comments: any[]) => {
      for (const comment of comments) {
        if (comment.users && typeof comment.users === 'string') {
          comment.users = JSON.parse(comment.users);
        }
      }
    };

    formatComments(this.project_comments_list);
    formatComments(this.task_comments_list);
    formatComments(this.this_step_comments);
    formatComments(this.other_step_comments);

    this.step.comments = this.this_step_comments;
    this.all_comments = all;
    this.total_comment_count = all.length;
    this.comments_loading = false;
  }

  GetFilteredStepComments() {
    if (this.comment_filter === 'Other Actions') return this.other_step_comments;
    if (this.comment_filter === 'Task') return this.task_comments_list;
    if (this.comment_filter === 'Project') return this.project_comments_list;
    return this.this_step_comments;
  }

  SetStepCommentFilter(filter: string) {
    this.comment_filter = filter;
    this.CancelStepReply();
  }

  StartStepReply(comment: any) {
    this.active_reply_guid = comment.guid;
    this.reply_comment = { reply_to: comment.guid, reply_to_text: comment.comment, reply_to_name: comment.users?.[0]?.display_name, comment: '', update: false };
  }

  CancelStepReply() {
    this.active_reply_guid = null;
    this.reply_comment = { reply_to: null, reply_to_text: null, reply_to_name: null, comment: '', update: false };
  }

  async SubmitStepReply(comment: any) {
    let url = 'steps/comments'; let guid = this.step.guid;
    if (comment.source_type === 'task') { url = 'tasks/comments'; guid = this.task.guid; }
    else if (comment.source_type === 'other_step') { url = 'steps/comments'; guid = comment.source_guid; }
    else if (comment.source_type === 'project') { url = 'projects/comments'; guid = this.project.guid; }

    const data: any = await this.apiService.post(`${url}/${guid}`, this.reply_comment);
    if (data.success) {
      const nc: any = data.data[0];
      nc.users = [{ display_name: this.current_user.display_name, guid: this.current_user.guid }];
      nc.comment = JSON.parse(JSON.stringify(this.reply_comment.comment));
      nc.reply_to_guid = this.reply_comment.reply_to;
      nc.source_type = comment.source_type; nc.source_title = comment.source_title; nc.source_guid = comment.source_guid;
      if (comment.source_type === 'task') this.task_comments_list.unshift(nc);
      else if (comment.source_type === 'other_step') this.other_step_comments.unshift(nc);
      else if (comment.source_type === 'project') this.project_comments_list.unshift(nc);
      else { this.this_step_comments.unshift(nc); if (this.step.comments) this.step.comments.unshift(nc); }
      this.all_comments.unshift(nc);
      this.total_comment_count = this.all_comments.length;
      this.CancelStepReply();
    }
    this.globalService.presentToastMessage(data.message, data.success);
  }

  async ViewOtherStep(comment: any) {
    const modal = await this.modalController.create({
      component: DetailsPage,
      componentProps: { guid: comment.source_guid, project: this.project, task: this.task },
      backdropDismiss: true,
      cssClass: 'large-modal secondary-modal'
    });
    modal.present();
  }

  async GoToStep(val) {
    this.activeIndex = val;
    if (val == 'Comments') {
      this.comment_filter = 'This Action';
      this.CancelStepReply();
      this.GetComments();
    }
  }

  Dismiss() {
    this.modalController.dismiss({ refresh: this.refresh });
  }

  @ViewChild('topRowRef', { static: false }) topRowRef: ElementRef | undefined;
  @ViewChild('footerRowRef', { static: false }) footerRowRef: ElementRef | undefined;
  @ViewChild('navRowRef', { static: false }) navRowRef: ElementRef | undefined;
  GetCommentsSize() {
    const el = this.topRowRef.nativeElement as HTMLElement;
    const rect = el.getBoundingClientRect();
    const footerEl = this.footerRowRef.nativeElement as HTMLElement;
    const footerRect = footerEl.getBoundingClientRect();
    const navEl = this.navRowRef.nativeElement as HTMLElement;
    const navRect = navEl.getBoundingClientRect();
    let allowed_size = Math.round(rect.height) - (Math.round(footerRect.height) + Math.round(navRect.height));
    console.log("Allowed Size:", allowed_size);
    return allowed_size - 1;
  }

  // The checklist's own "everything is checked, mark it complete?" prompt was accepted - reload the action
  OnChecklistCompleted() {
    this.refresh = true;
    this.GetData();
  }

  // A checklist can only be completed once every item is checked (and only once its items have loaded - the shared
  // step component parses them onto step.data when it renders)
  IsChecklistReadyToComplete(): boolean {
    const items = this.step?.data?.items;
    return Array.isArray(items) && items.every((i: any) => i.checked);
  }

  async StartStep(require_confirm) {
    if (require_confirm) {
      const alert = await this.alertController.create({
        header: 'Previous Action Not Completed',
        message: 'The previous task/action has not been completed yet. It\'s recommended to finish or mark the previous task/action as completed before starting this action. Would you like to start this action still?',
        buttons: [
          {
            text: 'Cancel',
            role: 'cancel'
          },
          {
            text: 'Start Action',
            handler: async () => {
              this.StartStepLogic();
            }
          }
        ]
      });

      await alert.present();
      const { role } = await alert.onDidDismiss();
      if (role === 'cancel') {
        return;
      }
    }
    else {
      this.StartStepLogic();
    }



  }

  // Applies to every client action that sends an email (ClientStepTypes) - a signature request is already
  // always reviewed through its own setup before it is sent.
  // step.data is normally parsed from steps_data by step-create-component when it renders, so parse it here
  // too in case Start is reached before that has happened.
  IsReviewBeforeSending(): boolean {
    if (!this.step || !ClientStepTypes.includes(Number(this.step.type))) return false;
    if (!this.step.data && this.step.steps_data?.[0]?.step_data) {
      try { this.step.data = JSON.parse(this.step.steps_data[0].step_data); } catch { }
    }
    return !!this.step.data?.review_before_sending;
  }

  BeginEmailReview() {
    if (this.step.status != 0) return;
    this.activeIndex = 'Details';
    this.review_mode = true;
    this.ChangeEditMode();
  }

  // Saves whatever was changed during the review, then starts the action, which sends the email.
  async SendReviewedEmail() {
    const saved = await this.UpdateStep();
    if (!saved) return;
    this.review_mode = false;
    await this.StartStepLogic(true);
  }

  async StartStepLogic(skip_review = false) {
    if (!skip_review && this.IsReviewBeforeSending()) {
      this.BeginEmailReview();
      return;
    }
    let started_data: any = null;
    await this.globalService.presentLoading(`Starting ${this.step.title}`, 30000);
    if (this.step.type == StepTypes.checkbox || this.step.type == StepTypes.upload_file || this.step.type == StepTypes.standard_operating_procedure || this.step.type == StepTypes.checklist) {
      started_data = await this.apiService.put(`steps/${this.step.guid}/complete/true`, null);
    }
    else if (this.step.type == StepTypes.email || this.step.type == StepTypes.approval_request || this.step.type == StepTypes.document_request || this.step.type == StepTypes.payment_request || this.step.type == StepTypes.signature_request || this.step.type == StepTypes.survey || this.step.type == StepTypes.webhook || this.step.type == StepTypes.conditional || this.step.type == StepTypes.activate_client_portal || this.step.type == StepTypes.appointment_request || this.step.type == StepTypes.question_request || this.step.type == StepTypes.checklist_request) {
      console.log("Start Step");
      started_data = await this.apiService.put(`steps/${this.step.guid}/start/true`, null);
    }
    console.log("Started Data: ", started_data);
    this.refresh = true;


    this.globalService.dismissLoading();
    await this.GetData();
    await this.WaitForStartedEmail();
  }

  // The server creates the email of a started action just after it answers, so the action can load with no email yet - which looks like
  // "no email was sent" until the window is reopened. Check again for a few seconds and reload once the email is there.
  private async WaitForStartedEmail() {
    if (!this.step || !this.IsEmailBackedStepType(this.step.type) || this.step.status == StepStatus.incomplete || this.GetStepEmailGuid()) return;
    const guid = this.step.guid;
    this.waiting_for_email = true;
    try {
      for (let attempt = 0; attempt < 10; attempt++) {
        await new Promise(resolve => setTimeout(resolve, 1500));
        if (this.step?.guid !== guid) return;
        const data: any = await this.apiService.get(`steps/${guid}`);
        if (data?.success && data.data?.[0]?.steps_data?.[0]?.email_guid) {
          await this.GetData();
          return;
        }
      }
    } finally {
      this.waiting_for_email = false;
    }
  }

  async MarkAsCompleted() {
    const alert = await this.alertController.create({
      header: 'Force Complete Action',
      message: 'Are you sure you want to force complete this action?',
      buttons: [
        {
          text: 'Cancel',
          role: 'cancel'
        },
        {
          text: 'Confirm',
          handler: async () => {
            await this.globalService.presentLoading(`Forcing Complete ${this.step.title}`, 30000);
            await this.apiService.put(`steps/${this.step.guid}/complete/true`, null);
            this.refresh = true;
            await this.globalService.dismissLoading();
            this.GetData();

          }
        }
      ]
    });

    await alert.present();
  }

  async MarkAsIncompleted() {
    const alert = await this.alertController.create({
      header: 'Mark Action as Incomplete',
      message: 'Are you sure you want to mark this action as incomplete?',
      buttons: [
        {
          text: 'Cancel',
          role: 'cancel'
        },
        {
          text: 'Confirm',
          handler: async () => {
            await this.globalService.presentLoading(`Marking ${this.step.title} as Incomplete`, 30000);
            await this.apiService.put(`steps/${this.step.guid}/complete/false`, null);
            this.refresh = true;
            await this.globalService.dismissLoading();
            this.GetData();
          }
        }
      ]
    });

    await alert.present();
  }

  async ChangeEditMode() {
    this.step_copy = JSON.stringify(this.step);
    this.edit_mode = true;
    console.log("STEP:", this.step);
  }

  async CancelEdit() {
    this.step = JSON.parse(this.step_copy);
    this.edit_mode = false;
    this.review_mode = false;
  }

  GetSignatureRequestSetupError(): string {
    if (!this.step?.data) return 'Step data is not loaded.';
    const messages: string[] = [];

    if (!this.step.data.subject || this.step.data.subject.trim() === '') {
      messages.push('Email subject is required.');
    }

    const hasPdf = (this.step.data.file_list || []).some(
      (f: any) => f.file_name && f.file_name.toLowerCase().endsWith('.pdf')
    );
    if (!hasPdf) {
      messages.push('At least one PDF file must be attached.');
    }

    return messages.join(' ');
  }

  async FinishSettingUpSignatureRequest() {
    if (this.GetSignatureRequestSetupError()) return;
    this.OpenESignatureSetup();
  }

  async OpenESignatureSetup() {
    let pdf_files = [];
    this.step.data.file_list.forEach(file => {
      if (file.file_name.includes(".pdf")) pdf_files.push(file);
    });
    const modal = await this.modalController.create({
      component: SetupPage,
      componentProps: {
        files: pdf_files,
        prepare_files: false,
        use_cert: this.step.data?.use_cert ?? true,
        client_guid: this.step.client_guid || '',
        company_guid: this.step.company_guid || '',
        role_guid: this.step.role_guid || '',
      },
      backdropDismiss: true,
      cssClass: 'large-modal secondary-modal'
    });
    modal.present();

    const { data, role } = await modal.onWillDismiss();
    if (data) {
      this.step.data.esignatures = data.map((esig: any) => ({ ...esig, use_cert: this.step.data?.use_cert ?? true }));
      console.log("Returned Data: ", this.step.data.esignatures);
      await this.UpdateStep();
      await this.StartStep(false);
    }
  }


  async UpdateStep() {
    if (this.clientStepTypes.includes(Number(this.step.type)) &&
        this.step.data?.send_to_different_role &&
        this.step.data?.override_role_guid &&
        this.step.company_guid) {
      const overrideRoleGuid = this.step.data.override_role_guid;
      const companyData: any = await this.apiService.get(`companies/${this.step.company_guid}`);
      if (companyData.success && companyData.data?.length > 0) {
        const company = companyData.data[0];
        const clients: any[] = company.clients || [];
        const hasDefault = clients.some((c: any) =>
          c.role_guid === overrideRoleGuid && c.is_default_for_role
        );
        if (!hasDefault) {
          this.globalService.presentToastMessage(
            `"${company.name}" does not have a default contact set for the selected "Send to Different Role" role. Please configure this in the company before saving.`,
            false
          );
          return false;
        }
      }
    }

    // Remove time component from due_date if it exists
    console.log(this.step.due_date);
    const dueDate = dayjs(this.step.due_date).format('YYYY-MM-DD') + ' 00:00:00.000';
    console.log("DUE DATE: ", dueDate);

    let post_data = {
      title: this.step.title,
      description: this.step.description,
      due_date: this.step.due_date ? dueDate : null,
      step_data: JSON.stringify(this.step.data)
    }
    console.log("Post data: ", post_data);
    let update_data: any = await this.apiService.put(`steps/${this.step.guid}`, post_data);
    if (update_data.success) this.edit_mode = false;
    this.globalService.presentToastMessage(update_data.message, update_data.success);
    return !!update_data.success;
  }


  async ViewEmailDetails() {
    const emailGuid = this.GetStepEmailGuid();
    if (!emailGuid) {
      this.globalService.presentToastMessage('No email was sent because this task was force completed before being started.', false);
      return;
    }

    const modal = await this.modalController.create({
      component: EmailDetailsPage,
      componentProps: {
        guid: emailGuid
      },
      backdropDismiss: true,
      cssClass: 'large-modal secondary-modal'
    });
    modal.present();
  }


  async ViewTask() {
    const modal = await this.modalController.create({
      component: TaskDetailsPage,
      componentProps: {
        guid: this.task.guid,
        project: this.project
      },
      backdropDismiss: true,
      cssClass: 'large-modal secondary-modal'
    });
    modal.present();
  }

  async ViewProject() {
    const modal = await this.modalController.create({
      component: ProjectDetailsPage,
      componentProps: {
        guid: this.project.guid
      },
      backdropDismiss: true,
      cssClass: 'large-modal secondary-modal'
    });
    modal.present();
  }

  // ---- Document Request Upload Methods ----

  async UploadDocumentToStep() {
    const modal = await this.modalController.create({
      component: UploadComponent,
      cssClass: 'small-modal secondary-modal',
      componentProps: {
        folder_guid: this.step.task_guid || '0'
      },
    });
    modal.present();

    const { data } = await modal.onDidDismiss();
    if (data && data.length > 0) {
      await this.globalService.presentLoading('Attaching files to step...', 30000);
      for (const file of data) {
        await this.apiService.post(`steps/${this.step.guid}/files/${file.guid}`, null);
      }
      // Store in step.uploaded_files for UI display
      if (!this.step.uploaded_files) this.step.uploaded_files = [];
      this.step.uploaded_files.push(...data);

      // Also add to step.data.file_list so they persist with the step data
      if (!this.step.data.file_list) this.step.data.file_list = [];
      this.step.data.file_list.push(...data);
      await this.SaveStepData();

      this.refresh = true;
      await this.globalService.dismissLoading();
      this.globalService.presentToastMessage('Files uploaded successfully', true);
    }
  }

  async UploadDocumentToSpecificRequest(specificFile: any) {
    const modal = await this.modalController.create({
      component: UploadComponent,
      cssClass: 'small-modal secondary-modal',
      componentProps: {
        folder_guid: this.step.task_guid || '0'
      },
    });
    modal.present();

    const { data } = await modal.onDidDismiss();
    if (data && data.length > 0) {
      await this.globalService.presentLoading(`Attaching files to ${specificFile.name}...`, 30000);
      for (const file of data) {
        await this.apiService.post(`steps/${this.step.guid}/files/${file.guid}`, { specific_file_name: specificFile.name });
      }
      // Store uploaded files on the specific file request object
      if (!specificFile.uploaded_files) specificFile.uploaded_files = [];
      specificFile.uploaded_files.push(...data);

      await this.SaveStepData();

      this.refresh = true;
      await this.globalService.dismissLoading();
      this.globalService.presentToastMessage(`Files uploaded to ${specificFile.name}`, true);
    }
  }

  async RemoveUploadedFile(file: any) {
    const alert = await this.alertController.create({
      header: 'Remove File',
      message: `Are you sure you want to remove ${file.file_name}?`,
      buttons: [
        { text: 'Cancel', role: 'cancel' },
        {
          text: 'Remove',
          handler: async () => {
            if (this.step.uploaded_files) {
              this.step.uploaded_files = this.step.uploaded_files.filter(f => f.guid !== file.guid);
            }
            if (this.step.data.file_list) {
              this.step.data.file_list = this.step.data.file_list.filter(f => f.guid !== file.guid);
            }
            await this.SaveStepData();
            this.refresh = true;
            this.globalService.presentToastMessage('File removed', true);
          }
        }
      ]
    });
    await alert.present();
  }

  async RemoveUploadedFileFromSpecific(specificFile: any, file: any) {
    const alert = await this.alertController.create({
      header: 'Remove File',
      message: `Are you sure you want to remove ${file.file_name} from ${specificFile.name}?`,
      buttons: [
        { text: 'Cancel', role: 'cancel' },
        {
          text: 'Remove',
          handler: async () => {
            if (specificFile.uploaded_files) {
              specificFile.uploaded_files = specificFile.uploaded_files.filter(f => f.guid !== file.guid);
            }
            await this.SaveStepData();
            this.refresh = true;
            this.globalService.presentToastMessage('File removed', true);
          }
        }
      ]
    });
    await alert.present();
  }

  DownloadFile(file: any) {
    this.apiService.DownloadFile(file);
  }

  GetMatchingEmailFile(guid: string) {
    if (!this.email || !this.email.files) return null;
    for (let i = 0; i < this.email.files.length; i++) {
      if (this.email.files[i].guid == guid) {
        return this.email.files[i];
      }
    }
    return null;
  }

  async UploadToEmailDocumentRequest(doc: any) {
    const emailGuid = this.GetStepEmailGuid();
    if (!emailGuid) {
      this.globalService.presentToastMessage('No email was sent because this task was force completed before being started.', false);
      return;
    }

    let additional_data = {
      document_request_guid: doc.guid,
      email_guid: emailGuid
    }
    const modal = await this.modalController.create({
      component: UploadComponent,
      cssClass: 'small-modal secondary-modal',
      componentProps: {
        folder_guid: this.step.task_guid || '0',
        additional_data: additional_data
      },
    });
    modal.present();

    const { data } = await modal.onDidDismiss();
    if (data && data.length > 0) {
      this.GetData();
    }
  }


  private async SaveStepData() {
    const postData = {
      title: this.step.title,
      description: this.step.description,
      due_date: this.step.due_date ? dayjs(this.step.due_date).format('YYYY-MM-DD') + ' 00:00:00.000' : null,
      step_data: JSON.stringify(this.step.data)
    };
    await this.apiService.put(`steps/${this.step.guid}`, postData);
  }

}
